/* eslint-disable */
import React, { useEffect } from "react";
import { getCommunityPolls } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const Polls = ({ getCommunityPolls, communityPolls, period }) => {
  useEffect(() => {
    getCommunityPolls({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityPolls(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getCommunityPolls(payload);
  };

  return (
    <DataTable
      preset="polls"
      data={{
        docs: communityPolls?.docs || [],
        totalPages: communityPolls?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityPolls: state.appCommunities.communityPolls,
});

const mapDispatchToProps = (dispatch) => ({
  getCommunityPolls: (payload) => dispatch(getCommunityPolls(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Polls);
